import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteCustomShiftNotification } from 'api/shifts/deleteCustomShiftNotification'
import { customShiftNotificationsKey } from './keys'

export const useDeleteCustomShiftNotificationMutation = (shiftId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (notificationId: number) =>
      deleteCustomShiftNotification({ shiftId, notificationId }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: customShiftNotificationsKey(shiftId),
      })
    },
  })
}
